<template>
  <div id="app">
    <router-view />
    <vue-snotify />
  </div>
</template>

<script>
import koMessages from './language/ko.json'
import { locale, loadMessages } from 'devextreme/localization'
import axios from 'axios'
import router from './router'
import ConstDef from '../../MesSmartVue/src/share/ConstDef'

export default {
  name: 'App',

  components: {

  },

  data: () => ({
    //
  }),
  created () {
    if (this.$route.path !== '/main' && this.$route.path !== '/') {
      const url = decodeURI(this.$route.path)
      this.$router.replace(url)
    }
    loadMessages(koMessages)
    locale(navigator.language)

    const arr = window.location.host.split(':')
    const host = window.location.protocol + '//' + arr[0]

    if (process.env.NODE_ENV === 'production') {
      const port = window.location.port
      ConstDef.apiUrl = `${host}:${port}${ConstDef.apiUrlProduction}`
      ConstDef.stompUrl = `${host}${ConstDef.stompPortProduction}`
    } else {
      ConstDef.apiUrl = host + ConstDef.apiUrlEvaluation
      ConstDef.stompUrl = `${host}${ConstDef.stompPortEvaluation}`
    }
    console.log('ConstDef.stompUrl')
    console.log(ConstDef.stompUrl)
  }
}
axios.interceptors.response.use( // response => response, (error) => {
  function (response) {
    ConstDef.errRetry = 0
    return response
  },
  async function (error) {
    console.log('interceptors Error')
    console.log(error.response)
    if (error.response.status === ConstDef.UNAUTHORIZED) {
      router.replace('/')
    } else if (error.response.status === ConstDef.BAD_REQUEST || error.response === undefined) {
      console.log('others System Error')
      // alert('시스템 이상(Erro Code:' + error.response.status + ')')
      if (ConstDef.errRetry < 2) {
        ConstDef.errRetry++
        return axios.request(error.config)
      } else {
        ConstDef.errRetry = 0
        return Promise.reject(error)
      }
    } else {
      console.log(error)
      return Promise.reject(error)
    }
  }
  // if (error.response === undefined) {
  //   alert('시스템 이상 잠시후 다시 접속 하세요')
  //   return Promise.reject(error)
  // } else if (error.response.status === ConstDef.FORBIDDEN) {
  //   alert('권한 없음')
  // } else if (error.response.status === ConstDef.UNAUTHORIZED) {
  //   router.replace('/')
  // } else if (error.response.status === ConstDef.BAD_REQUEST || error.response.status === ConstDef.NOT_FOUND) {
  //   console.log('others System Error')
  //   alert('시스템 이상(Erro Code:' + error.response.status + ')')
  //   return Promise.reject(error)
  // } else if (error.response.data.status === ConstDef.DUPLICATE_LOGIN) {
  //   console.log(error.response)
  //   alert(error.response.data.message)
  //   router.replace('/')
  // } else {
  //   console.log(error)
  //   return Promise.reject(error)
  // }
)
</script>

<style lang="scss">

</style>
